export const TOKEN_SUCCESS = 'TOKEN_SUCCESS';
export const updateToken = accessToken => dispatch => {
    dispatch({
        type: TOKEN_SUCCESS,
        payload: {
            accessToken
        }
    })
};
